import ProfileInfoSection from "./ProfileInfoSection";

export default ProfileInfoSection;
